import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from '@/hooks/useTheme'
import { TransactionStateTypes } from '@/domain/transfer/transferTypes'

interface StatusColorAndLabel {
  color: string
  label: string
}

export const useGetTransactionStatusColorAndLabel = (
  status?: TransactionStateTypes,
): StatusColorAndLabel => {
  const { t } = useTranslation()
  const theme = useTheme()

  return useMemo(() => {
    switch (status) {
      case 'completed':
        return {
          color: theme.colors.label.success || '#34C759',
          label: t('translation:completed') || 'Completed',
        }
      case 'pending':
        return {
          color: theme.colors.label.description || '#8E8E93',
          label: t('translation:pending') || 'Pending',
        }
      case 'processing':
        return {
          color: theme.colors.label.description || '#8E8E93',
          label: t('translation:processing') || 'Processing',
        }
      case 'failed':
        return {
          color: theme.colors.label.flagLoss || '#FF3B30',
          label: t('translation:failed') || 'Failed',
        }
      case 'cancelled':
        return {
          color: theme.colors.label.flagLoss || '#FF3B30',
          label: t('translation:cancelled') || 'Cancelled',
        }
      default:
        return {
          color: theme.colors.label.default || '#000000',
          label: t('translation:unknown') || 'Unknown',
        }
    }
  }, [status, t, theme])
}
